console.log('Zepto Custom works');
var saveFrame;
window.addEventListener("pplrAppBuild", function (e) {
    let savePreview = $('.pplr-wrapper.pplr-save-info');
    saveFrame = $(savePreview).data('main');
    if(savePreview.length){
        let buttonName = $(savePreview).find('.pplr_text').attr('placeholder');
        $('.pplr-popup .pplr_ex_inner').append(`<button type="button" class="btn button pplr-save-info" style="
        margin-left: 5px;">${buttonName}</button>`);
    }

    let storage = JSON.parse(localStorage.getItem('productCache') || '{}');
    let formsData = JSON.parse(storage[getProductHandle()] || '{}');

    if(formsData){
        setTimeout(() => {
            setFormData(formsData);
        }, 500);
        console.log(formsData)
    }


    $(savePreview).hide();
    $('.pplr-save-info').click(e, saveFormsData)

    let successMessage; //'Saved Success';
    if(_SJ[13] == '1'){
        successMessage = $('.pplr-wrapper.pplr-save-info .pplr_text').parent().find('.pplrlabel').find('.ptbr')[0].nextSibling.nodeValue;
    }else if(_SJ[13] == '2'){
        successMessage = $('.pplr-wrapper.pplr-save-info .pplr_text').parent().find('.ptooltiptext').html();
    }else if(SJ[13] == '3'){
        successMessage = $('.pplr-wrapper.pplr-save-info .pplr_ins').html()
    }

    if(!successMessage) successMessage = 'Saved Success'; 

    $('.pplr_ex_button').append(`<div class="pplr_confirm_save" style="float: left;background: #d3d3d34d;width: calc(50% - 15px);display: none;
    align-items: center;justify-content: center;font-weight: bold;padding: 13px;
    margin: 10px 10px 0px 5px;border-radius: 8px;border: 1px solid lightgray;transition: display 1s;">${successMessage}</div>`);
    
});

  window.addEventListener("pplrAppInitiated", function (e) {
  
  
  });

function saveFormsData() {
    let formsData = getFormsData();

    let formsStr = JSON.stringify(formsData);
    let storage = JSON.parse(localStorage.getItem('productCache')) || {};
    storage[getProductHandle()] = formsStr;
    localStorage.setItem('productCache', JSON.stringify(storage))

    $('.pplr_ex_button .pplr_confirm_save').css({
        display: 'flex'
    })

    setTimeout(() => {$('.pplr_ex_button .pplr_confirm_save').hide();}, 2000)
}

function getProductHandle() {
    return location.pathname.split('/')[2];
}
    
function setFormData(formData) {
    let canvasRendered = false;
    let formSelector = '.pplr-popup form';
    Object.keys(formData).map(key => {
        if(key.includes('properties')){
            let elem = $(`[name="${key}"]input, [name="${key}"]textarea, [name="${key}"]select`);
            if(formData[key] && typeof formData[key] != 'object'){
                $(elem).val(formData[key]);
                let totalPrice = 0;
                if($(elem).hasClass('pplr_text')){
                    let name = $(elem).attr('name').match(/\[(.*?)\]/)[1];
                    let fonts = $(elem).siblings('.textBiggerSmaller');
                    let alignment = $(elem).siblings('.pplr-btn-group');

                    if($(fonts).length){
                        let propName = `properties[_font size ${name}]`;
                        $(`[name="${propName}"]`).val(formData[propName]);
                        $(`[name="${propName}"]`).attr("data-size", (parseFloat(formData[propName]) * (1 + window.pplr_font_factor / 100)).toFixed(10));
                    }
                    if($(alignment).length){
                        let propName = `properties[_align ${name}]`;
                        $(`[name="${propName}"]`).val(formData[propName]);
                        $(`[name="${propName}"]`).siblings('button').removeClass('active')
                        $(`[name="${propName}"]`).siblings('button').each((i, e) => {
                            if($(e).attr('title').toLowerCase() == formData[propName]) $(e).addClass('active');
                        })
                    }
                }else if($(elem).siblings('.pplr-swatch-main').length){
                    let els = $(elem).siblings('.pplr-swatch-main').find('span');
                    let variants = [];
                    let tag;

                    $(els).removeClass('selected');
                    $(els).each((i,e) => {
                        let values = formData[key]?.split(', ');
                        if(values.includes($(e).data('val')) || values.includes($(e).data('name'))){
                            setTimeout(() => {
                                $(e).addClass('selected');
                            }, 400)
                            
                            if($(e).data('image')){
                                $(elem).siblings('.img_url').each((i, el) => {
                                    $(el).attr('data-psrc', $(e).data('image'))
                                })
                                
                            }
                            if($(e).data('color')){
                                $(elem).attr('data-value', $(e).data('color'));     
                            }
                            if($(e).data('pplr_price')){
                                totalPrice += parseFloat($(e).data('pplr_price') || 0);     
                            }
                            if($(e).data('variant')){
                                variants.push($(e).data('variant'))
                            }
                            tag = $(e).data('tag');
                        }
                        
                    })
                    $(elem).parent().find('.pplr_option_text_span').html(' - '+ $(elem).val());
                    if(totalPrice) $(elem).attr('data-pplr_price', totalPrice);
                    if(variants.length) $(elem).attr('data-variant', variants.join('||'));
                    if(tag){
                        let tags = $(elem).siblings('.pplr-swatch-main');
                        $(tags).find(`span[data-tag!="${tag}"].pplrimage`).css({display: 'none'})
                        $(tags).find(`span[data-tag="${tag}"].pplrimage`).css({display: 'block'})
                        $(tags).find('.pplr_tag span').removeClass('active');
                        $(tags).find(`.pplr_tag span[data-val="${tag}"]`).addClass('active');
                    }
                }else if($(elem).hasClass('pplr_select')){
                    if($(elem).siblings('.pplr-drop-item').length){
                        let values = formData[key]?.split(', ');
                        let price = 0;
                        let isPrice = false;
                        
                        $(elem).siblings('.pplr-drop-item')?.each((i,e) => {
                            $(e).removeClass('active');
                            if(values.includes($(e).data('value'))){
                                $(e).addClass('active');
                                if($(e).data('pplr_price')){
                                    isPrice = true;
                                    price += parseFloat($(e).data('pplr_price') || 0)  
                                }
                                if(isPrice) $(elem).attr('data-pplr_price', price);
                                $(elem).parent().find('.pplr_option_text_span').html(' - '+ $(elem).val());
                            }
                        }) 
                    }
                    if($(elem).find('option').length){
                          $(elem).find('option').removeClass('selected')
                        $(elem).find('option').each((i,e) => {
                            if($(e).val() == formData[key]){
                                $(e).addClass('selected');
                                $(elem).attr('data-variant', $(e).data('variant'))
                                $(elem).attr('data-pplr_price', $(e).data('pplr_price'))
                                $(elem).addClass('pplraddprice');
                            }
                        })
                    }
                }else if($(elem).hasClass('pplrcheckbox')){
                    if($(elem).hasClass('pplr_mselect')){
                        let values = formData[key].split(', ');
                        let totalPrice = 0;
                        let variants = [];
                        $(elem).parent().siblings('.pplr_checkbox_l')?.each((i,e) => {
                            $(e).find('input').removeClass('active');
                            $(e).find('input').prop('checked', false)
                            if(values.includes($(e).find('input').data('value'))){
                                $(e).find('input').addClass('active');
                                $(e).find('input').prop('checked', true);

                                totalPrice += parseFloat($(e).find('input').data('pplr_price') || 0);
                                if($(e).find('input').data('p-variant')){
                                    variants.push($(e).find('input').data('p-variant'))
                                }
                                
                            }
                        })
                        if(variants.length) $(elem).attr('data-variant', variants.join('||'));
                        if(totalPrice){
                            $(elem).attr('data-pplr_price', totalPrice).addClass('pplraddprice');
                        }
                        
                    }else{
                        if(formData[key] == 'Yes'){
                            $(elem).prop('checked', true)
                        }
                    }
                    
                }else if($(elem).hasClass('pplr_font')){
                    // console.log($(elem), $(elem).siblings('.pplr-selecter-selected'))
                    // console.log($(elem))
                    let styleFont = '';
                    $(elem).siblings('.pplr-selecter-selected').html(formData[key])
                    $(elem).siblings('.pplr-selecter-options').find('.pplr-selecter-item').each((i, e) => {
                        $(e).removeClass('selected-font');
                        if($(e).data('name') == formData[key]){
                            styleFont = $(e).data('value');
                            $(e).addClass('selected-font');
                            let price = $(e).data('pplr_price');
                            let height = $(e).data('height');
                            $(elem).attr('data-pplr_price', price);
                            $(elem).attr('data-height', height);
                        }
                    })
                    styleFont = styleFont.split('.')[0];

                    $(elem).each((i,e) => {
                        let frame = $(e).data('frame');
                        $(`.pplr-wrapper[data-main="${frame}"] input`).css({fontFamily: styleFont});
                    })

                    
                    $(elem).siblings('.pplr-selecter-selected').css({fontFamily: styleFont});
                }


            }else{
                if($(elem).hasClass('fileupload')){
                    let frame = $(elem).data('frame');
                    let cropValue = formData['_Crop_x_y_width_height(px)_rotate '+ frame];
                    canvasimagepplr($(elem)[0], formData[key + '_psrc'], frame);
                    canvasRendered = true;
                    pplr_hide(2);
                    setTimeout(() => {
                        $(elem).siblings('.pplr-crop').val(cropValue);
                        LoadPplrWithFont(saveFrame,true,$(".pplr-wrapper[data-main='1'] input")[0]);
                    }, 700);
                    // let blobUrl = dataurlToBlobUrl(formData[key + '_psrc'])
                    
                    // setTimeout(() => {
                    //     canvasimagepplr($(elem)[0], formData[key + '_psrc'], frame);
                    //     setTimeout(() => {
                    //         // console.log($(`.pplr-modal-img[data-frame="2"]`).data('cropper').cropBox);
                    //         let cropbox = JSON.parse(formData[key + '_cropbox']);
                    //         $(`.pplr-modal-img[data-frame="${frame}"]`).data('cropper').cropBox = cropbox;
                    //         // let css = `width: ${cropbox.width.toFixed(3)}px;height: ${cropbox.height.toFixed(3)}px;transform: traslateX(${cropbox.left.toFixed(3)}px) traslateY(${cropbox.top.toFixed(3)}px)`;
                    //         // $(`.pplr-modal-img[data-frame="${frame}"]`).data('cropper').$cropBox[0].style.cssText = css;
                    //         $(`.crop_header[data-frame="${frame}"] .cropper-crop-box`).css({
                    //           'width': cropbox.width.toFixed(3) +'px',
                    //           'height': cropbox.height.toFixed(3)+'px',
                    //           'transform': `translateX(${cropbox.left.toFixed(3)}px) translateY(${cropbox.top.toFixed(3)}pxpx)`
                    //         });
                    //         $(elem).siblings('.pplr-crop').val(cropValue);
                    //         LoadPplrWithFont('1',true,$(".pplr-wrapper[data-main='1'] input")[0]);
                    //         canvasRendered = true;
                    //         console.log(cropValue, 'sgsduh');
                            
                    //     }, 500)
                        
                    //     // $(elem).parent().siblings('.jscroll').find('ul').append(`<li class="pplr_img_w" data-name="Image Upload option"><a data-f="${frame}" class="pplr_img" href="${blobUrl}" style="background-image: url(&quot;${blobUrl}&quot;); transform: rotate(0deg);"></a><a class="pplr_shadow"></a><a class="pplr_modify" onclick="pplr_modify(${frame},600,600,0,600)"><i class="pfa fa-edit"></i></a><a class="pplr_delete" onclick="pplr_delete(${frame},true)"><i class="pfa fa-trash-o"></i></a></li>`)
                    // }, 1000)
                    // pplr_hide(2);
                    // $(elem).parent().parent().addClass('p_h_m');
                    // $(".pplr_tab_wrapper > div:nth-child(1)").click();

                    
            }
            }
        }


        // if(formData[key] || formData[key] === false){

            // if($(elem).hasClass('pplr-swatch-element')){
            //     $(elem).parent().find('.pplr_deselect')?.click();

            //     let values = formData[key].split(', ');
            //     $(elem).each((i, e) => {
            //         if(values.includes($(e).data('val'))) $(e).click();
            //     })
            // }else if($(elem).hasClass('pplr_select')){
            //     let values = formData[key].split(', ');

            //     $(elem).val(formData[key])
            //     if($(elem).siblings('.pplr-drop-item').length){
            //         $(elem).siblings('.pplr-drop-item')?.each((i,e) => {
            //             if(values.includes($(e).data('value'))) $(e).click();
            //         })
            //     }
            // }else if($(elem).hasClass('pplr_text')){
            //     $(elem).val(formData[key])
            //     $(elem).change();
            // }else if($(elem).hasClass('pplr_font')){
            //     let options = $(elem).siblings('.pplr-selecter-options').find('.pplr-selecter-item');
            //     options.each(function (i, e) {
            //         if(formData[key] == e.innerHTML){
            //             $(e).click();
            //         }
            //     })
            // }else if($(elem).hasClass('pplrcheckbox')){
            //     $(elem).val(formData[key])
            //     if($(elem).hasClass('pplr_mselect')){
            //         let values = formData[key].split(', ');
            //         $(elem).parent().siblings('.pplr_checkbox_l')?.each((i,e) => {
            //             if(values.includes($(e).find('input').data('value'))) $(e).find('input').click();
            //         })
            //     }else{
            //         if(formData[key]){
            //             $(elem).prop('checked', true);
            //         }else{
            //             $(elem).prop('checked', false);
            //         }
            //     }
                
            // }else if($(elem).hasClass('pplrjscolor')){
            //     colors = $(elem).siblings('.pplrgcolor')?.find('.pplr-swatch-element');
            //     $(colors).each((i,e) => {
            //         if($(e).data('name') == formData[key]){
            //             $(e).click();
            //         }
            //     })
            // }else if($(elem).hasClass('fileupload')){
            //     let frame = $(elem).data('frame');
                
            //     console.log($(elem).siblings('.pplr-crop').val());
            //     setTimeout(() => {
            //         canvasimagepplr($(elem)[0], formData[key], frame);
            //         pplr_hide(2);
            //         $(".pplr_tab_wrapper > div:nth-child(1)").click();
            //         $(elem).siblings('.pplr-crop').val(formData[key + '_crop']);
            //         $(elem).siblings('.pplr-crop').change();
            //     }, 200)
            //     // let blobUrl = dataurlToBlobUrl(formData[key])
            //     // $(elem).parent().siblings('.jscroll').find('ul').append(`<li class="pplr_img_w" data-name="Image Upload option"><a data-f="${frame}" class="pplr_img" href="${blobUrl}" style="background-image: url(&quot;${blobUrl}&quot;); transform: rotate(0deg);"></a><a class="pplr_shadow"></a><a class="pplr_modify" onclick="pplr_modify(${frame},600,600,0,600)"><i class="pfa fa-edit"></i></a><a class="pplr_delete" onclick="pplr_delete(${frame},true)"><i class="pfa fa-trash-o"></i></a></li>`)
            // }
        // }

        
    })
    updatecondition();

    if(!canvasRendered){
        LoadPplrWithFont(saveFrame,true,$(".pplr-wrapper[data-main='1'] input")[0]);
    }




        // fields = $(`${formSelector} .pplr_select[name^="properties["], 
        // ${formSelector} .pplrjscolor[name^="properties["],
        // ${formSelector} .pplr_font[name^="properties["],
        // ${formSelector} .pplr_mselect[name^="properties["],
        // ${formSelector} .pplrcheckbox.pplr_mselect[name^="properties["],
        // ${formSelector} [type="text"][name^="properties["]`);
        // console.log(fields);
        // fields.each((i, e) => {
        //     let name = $(e).attr('name');
        //     // console.log(name);
        //     if(formData[name] || formData[name] === false){
        //         $(e).val(formData[name]);
        //     }
        // })
        
        // $('.pplr-popup form input').trigger('change');

}

function getFormsData() {

    var formData = new FormData($(".pplr-popup form")[0]);
    let formsObj = {};
    for (const pair of formData.entries()) {
      // console.log(`${pair[0]}, ${pair[1]}`);
      formsObj[pair[0]] = pair[1];
        if(typeof pair[1] == 'object'){
            formsObj[pair[0] + '_psrc'] = $(`[name="${pair[0]}"]`).siblings('.img_url').data('psrc')
            let frame = $(`[name="${pair[0]}"]`).data('frame')
            formsObj[pair[0] + '_cropbox'] = JSON.stringify($(`.pplr-modal-img[data-frame="${frame}"]`).data('cropper').cropBox);
            console.log(formsObj[pair[0] + '_cropbox'], pair[0] + '_cropbox')
            // console.log($(`[name="${pair[0]}"]`).siblings('.img_url').data('psrc'))
        }
    }

    // let formSelector = '.pplr-popup form';

    // $('form.pplr_form').serializeArray();

    // Image swatch
    // let fields = $(`${formSelector} .pplr-swatch-element.selected[name^="properties["]`);
    // fields.each((i, e) => {
    //     formsObj[$(e).attr('name')] = $(e).data('val');
    // })

    // fields = $(`${formSelector} .pplr_select[name^="properties["], 
    //     ${formSelector} .pplrjscolor[name^="properties["],
    //     ${formSelector} .pplr_font[name^="properties["],
    //     ${formSelector} .pplr_mselect[name^="properties["],
    //     ${formSelector} .pplrcheckbox.pplr_mselect[name^="properties["],
    //     ${formSelector} [type="text"][name^="properties["]`);
    // fields.each((i, e) => {
    //     formsObj[$(e).attr('name')] = $(e).val();
    // })

    // fields = $(`${formSelector} [type="checkbox"][name^="properties["]`);
    // fields.each((i, e) => {
    //     formsObj[$(e).attr('name')] = $(e).prop('checked');
    // })

    // fields = $(`${formSelector} .fileupload[name^="properties["]`);
    // fields.each((i, e) => {
    //     let srcList = $(e).siblings('.img_url');
    //     $(srcList).each((index,s) => {
    //         let src = $(s).data('psrc');
    //         formsObj[$(e).attr('name')] = src;
    //         formsObj[$(e).attr('name') + '_crop'] = $(e).siblings('.pplr-crop').val();
    //     })
        
    // })

    console.log(formsObj)

    return formsObj;

}


function getCartData() {

    let urlParams = new URLSearchParams(new URL(location.href).search);
    let key = urlParams.get('edit');
    let properties;

    if(key){
        console.log(window.pplr_cart);
        let exists = pplr_cart.items.find((item) => item.key == key);
        if(exists) properties = exists.properties;
        console.log(properties);
    }
    
    
}

getCartData();

